import { DynamicLeadFormType } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsSeo.ViewModels.DynamicLeadFormType */
export { DynamicLeadFormType };
import { BrandType } from "../../../../CoStar/Api/AptsFeatures/ViewModels/Common/index.js";
/** CoStar.Api.AptsSeo.ViewModels.BrandType */
export { BrandType };
/** CoStar.Api.AptsSeo.ViewModels.ListingRedirectSource */
export var ListingRedirectSource;
(function (ListingRedirectSource) {
    ListingRedirectSource[ListingRedirectSource["Unknown"] = 0] = "Unknown";
    ListingRedirectSource[ListingRedirectSource["PropertyMerge"] = 1] = "PropertyMerge";
    ListingRedirectSource[ListingRedirectSource["ChangeOfPropertyManagement"] = 2] = "ChangeOfPropertyManagement";
    ListingRedirectSource[ListingRedirectSource["ManualEntry"] = 3] = "ManualEntry";
    ListingRedirectSource[ListingRedirectSource["SkynetTier2ToActive"] = 4] = "SkynetTier2ToActive";
    ListingRedirectSource[ListingRedirectSource["SkynetActiveToTier2"] = 5] = "SkynetActiveToTier2";
    ListingRedirectSource[ListingRedirectSource["SkynetFlatten"] = 6] = "SkynetFlatten";
})(ListingRedirectSource || (ListingRedirectSource = {}));
/** CoStar.Api.AptsSeo.ViewModels.ListingRedirectStatus */
export var ListingRedirectStatus;
(function (ListingRedirectStatus) {
    ListingRedirectStatus[ListingRedirectStatus["Unknown"] = 0] = "Unknown";
    ListingRedirectStatus[ListingRedirectStatus["Active"] = 1] = "Active";
    ListingRedirectStatus[ListingRedirectStatus["Inactive"] = 2] = "Inactive";
})(ListingRedirectStatus || (ListingRedirectStatus = {}));
/** CoStar.Api.AptsSeo.ViewModels.SeoRedirectType */
export var SeoRedirectType;
(function (SeoRedirectType) {
    SeoRedirectType[SeoRedirectType["None"] = 0] = "None";
    SeoRedirectType[SeoRedirectType["NeighborhoodSearch"] = 1] = "NeighborhoodSearch";
    SeoRedirectType[SeoRedirectType["NeighborhoodLocal"] = 2] = "NeighborhoodLocal";
    SeoRedirectType[SeoRedirectType["ExactPath"] = 3] = "ExactPath";
})(SeoRedirectType || (SeoRedirectType = {}));
/** CoStar.Api.AptsSeo.ViewModels.SeoRedirectsSortColumn */
export var SeoRedirectsSortColumn;
(function (SeoRedirectsSortColumn) {
    SeoRedirectsSortColumn[SeoRedirectsSortColumn["None"] = 0] = "None";
    SeoRedirectsSortColumn[SeoRedirectsSortColumn["FromUrl"] = 1] = "FromUrl";
    SeoRedirectsSortColumn[SeoRedirectsSortColumn["DestinationUrl"] = 2] = "DestinationUrl";
    SeoRedirectsSortColumn[SeoRedirectsSortColumn["CreatedDate"] = 3] = "CreatedDate";
})(SeoRedirectsSortColumn || (SeoRedirectsSortColumn = {}));
/** CoStar.Api.AptsSeo.ViewModels.SeoRedirectsSortDirection */
export var SeoRedirectsSortDirection;
(function (SeoRedirectsSortDirection) {
    SeoRedirectsSortDirection[SeoRedirectsSortDirection["None"] = 0] = "None";
    SeoRedirectsSortDirection[SeoRedirectsSortDirection["Ascend"] = 1] = "Ascend";
    SeoRedirectsSortDirection[SeoRedirectsSortDirection["Descend"] = 2] = "Descend";
})(SeoRedirectsSortDirection || (SeoRedirectsSortDirection = {}));
/** CoStar.Api.AptsSeo.ViewModels.SitemapProfileType */
export var SitemapProfileType;
(function (SitemapProfileType) {
    SitemapProfileType[SitemapProfileType["None"] = 0] = "None";
    SitemapProfileType[SitemapProfileType["Diamond"] = 1] = "Diamond";
    SitemapProfileType[SitemapProfileType["Platinum"] = 2] = "Platinum";
    SitemapProfileType[SitemapProfileType["Gold"] = 3] = "Gold";
    SitemapProfileType[SitemapProfileType["Silver"] = 4] = "Silver";
    SitemapProfileType[SitemapProfileType["BasicProperty"] = 5] = "BasicProperty";
    SitemapProfileType[SitemapProfileType["BasicSpm"] = 6] = "BasicSpm";
    SitemapProfileType[SitemapProfileType["BasicFeed"] = 7] = "BasicFeed";
    SitemapProfileType[SitemapProfileType["NotSearchable"] = 8] = "NotSearchable";
    SitemapProfileType[SitemapProfileType["Tier2"] = 9] = "Tier2";
})(SitemapProfileType || (SitemapProfileType = {}));
